(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[824],{

/***/ 699:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/default-splash-card.0ded0b20.png","height":1667,"width":1667,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAqElEQVR42iWOOQrCABBF5wiC4lKIW+GWmEWSVo8QUAhoE21SBtLmDIE0aXOAtDmC1mlyn4cZhAczzPzP/4JhYjs4Lu5Zl5OFeeoRHZMZgyEizBcslmx3/Vs4GjyevN4kCbc7QcDlym4veD5VRdPQddQ1aUoUsVqLGsNQhWVJ2/L5kueIiKatN4iQZRSFXuOY0Vi0lWVrq/0BEWU8xXa01R+1en6PigzzB2D/YcmSCI2wAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 3065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(699);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);





const baseUrl = "https://www.casperlabs.io/";
const siteName = "Casper Labs";
function CustomHead(param) {
    let { title , description ="" , og , twitter , business , children  } = param;
    if (!og) {
        og = {
            ogTitle: title,
            ogDescription: description,
            ogImage: _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src
        };
    }
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const key = (0,react__WEBPACK_IMPORTED_MODULE_4__.useId)();
    const ogUrl = "".concat(baseUrl.substring(0, baseUrl.length - 1)).concat(router.asPath);
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "192x192",
                href: "/android-chrome-192x192.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "512x512",
                href: "/android-chrome-512x512.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "".concat(baseUrl, "icons/navbar-toggle-icon.webp"),
                as: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: "Casper Labs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "googlebot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "bingbot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: "5dpoinx6gwzawxktv7aakmzim1f23c"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: og.ogTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: og.ogDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: og.ogImage
            }),
            twitter && Object.keys(twitter).map((p)=>{
                const content = twitter[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:".concat(p),
                    content: content
                }, key + p);
            }),
            business && Object.keys(business).map((p)=>{
                const content = business[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "business:contact_data:".concat(p),
                    content: content
                }, key + p);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children
        ]
    }));
}


/***/ }),

/***/ 5039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HotspotModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5015);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _atk_components_loaders_ListLoader_ListLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1608);
/* harmony import */ var _atk_hooks_useHotspotForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7602);
/* harmony import */ var _HotspotModal_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6025);
/* harmony import */ var _HotspotModal_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_HotspotModal_module_scss__WEBPACK_IMPORTED_MODULE_9__);







function HotspotModal(param) {
    let { formId , target , showModal , handleClose , children  } = param;
    const { loading , initHotspotForm  } = (0,_atk_hooks_useHotspotForm__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        region: "na1",
        portalId: "6073987",
        formId,
        target
    });
    const [showToast, setShowToast] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(()=>{
        if (showModal) {
            const timerHubspot = setTimeout(()=>{
                initHotspotForm();
            }, 100);
            const timer = setTimeout(()=>{
                const el = document.getElementById(target.replace("#", ""));
                if (el && !el.hasChildNodes()) {
                    handleClose();
                    setShowToast(true);
                }
            }, 10000);
            return ()=>{
                clearTimeout(timerHubspot);
                clearTimeout(timer);
            };
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showModal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                centered: true,
                className: "custom-modal",
                show: showModal,
                onHide: handleClose,
                fullscreen: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Header */ .Z.Header, {
                        closeButton: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Body */ .Z.Body, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: "modal-container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: "justify-content-center",
                                children: [
                                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atk_components_loaders_ListLoader_ListLoader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "formContainer",
                                        children: children
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: (_HotspotModal_module_scss__WEBPACK_IMPORTED_MODULE_9___default().toast),
                onClose: ()=>setShowToast(false),
                show: showToast,
                delay: 5000,
                autohide: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Body */ .Z.Body, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Sorry, this form is no longer available."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    "You can request this content through our",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: "/contact?section=contactForm",
                                        children: " Contact Us"
                                    }),
                                    " page."
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 1608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ListLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6968);
/* harmony import */ var _ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5973);
/* harmony import */ var _ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1__);




function ListLoader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loaderContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "mt-5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                md: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "text-green",
                    animation: "border",
                    role: "status",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FramerMotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3838);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



function FramerMotion(param) {
    let { children , animation ="fadeUp" , y  } = param;
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setIsMobile(window.innerWidth <= 768);
        const handleResize = ()=>{
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    if (isMobile) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: children
    });
    const fadeInProps = {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    };
    const fadeUpProps = {
        initial: {
            opacity: 0,
            y: y && y || 250
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        transition: {
            type: "spring",
            stiffness: 50,
            duration: 2
        },
        viewport: {
            once: true
        },
        className: "framerMotion"
    };
    const animationProps = animation === "fadeIn" ? fadeInProps : fadeUpProps;
    const { ...motionProps } = animationProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        ...motionProps,
        children: children
    });
}


/***/ }),

/***/ 7602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHotspotForm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const reducer = (currentState, newState)=>{
    return {
        ...currentState,
        ...newState
    };
};
function useHotspotForm(param) {
    let { region , portalId , formId , target , autohide  } = param;
    const initialState = {
        loading: true,
        show: false
    };
    const [{ loading , show  }, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, initialState);
    const toggleShow = ()=>setState({
            show: !show
        });
    const noShow = ()=>{
        setState({
            show: false
        });
        initHotspotForm();
    };
    const initHotspotForm = ()=>{
        hbspt.forms.create({
            region,
            portalId,
            formId,
            target,
            onFormReady: ()=>{
                setState({
                    loading: false
                });
            },
            onBeforeFormInit: (ctx)=>{
                if (ctx.pageUrl) {
                    setState({
                        loading: false
                    });
                }
            },
            onFormSubmitted: function() {
                setState({
                    show: true
                });
                if (autohide) {
                    const timerHubspot = setTimeout(()=>{
                        noShow();
                    }, 5000);
                    return ()=>{
                        clearTimeout(timerHubspot);
                    };
                }
            }
        });
    };
    return {
        loading,
        show,
        toggleShow,
        noShow,
        initHotspotForm
    };
}


/***/ }),

/***/ 2045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BannerSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5005);
/* harmony import */ var react_bootstrap_Carousel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7279);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _atk_components_layout_Modal_HotspotModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5039);
/* harmony import */ var _atk_hooks_framerMotion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(658);
/* harmony import */ var _BannerSlider_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2302);
/* harmony import */ var _BannerSlider_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_BannerSlider_module_scss__WEBPACK_IMPORTED_MODULE_6__);









var _target;
const CTAButton = (param)=>/*#__PURE__*/ {
    let { linkButton , onClick  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        onClick: ()=>linkButton.hubspotFormId && onClick(linkButton.hubspotFormId),
        className: "me-lg-3 mb-3 mb-lg-0",
        variant: linkButton.variant,
        href: !linkButton.hubspotFormId ? linkButton.link : undefined,
        target: (_target = linkButton.target) !== null && _target !== void 0 ? _target : "_self",
        children: linkButton.label
    });
};
function BannerSlider(props) {
    const { customClass ="" , interval =null , slides =[]  } = props;
    const [showReportModal, setShowReportModal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [hubspotFormId, setHubspotFormId] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const handleCloseReportModal = ()=>setShowReportModal(false);
    const handleHubspot = (formId)=>{
        setHubspotFormId(formId);
        setShowReportModal(true);
    };
    const hideArrowClass = slides.length === 1 ? "bannerSliderHideArrow" : "";
    const componentClass = "bannerSlider ".concat((_BannerSlider_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bannerSlider), "  ").concat(customClass, " ").concat(hideArrowClass);
    const slideInterval = slides.filter((x)=>x.isAnimated).length > 0 ? interval : null;
    var _body, _body1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: componentClass,
        id: props.id,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Carousel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                indicators: false,
                interval: slideInterval,
                children: slides.map((slide, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Carousel__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Item */ .Z.Item, {
                        className: "".concat((_BannerSlider_module_scss__WEBPACK_IMPORTED_MODULE_6___default().slide), " ").concat(slide.imgSrc && "bg-gradient-brown" || "bg-gradient-blue-purple"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: "d-flex flex-column justify-content-center h-100",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atk_hooks_framerMotion__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                y: 50,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    className: "align-items-center",
                                    children: slide.imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                lg: 6,
                                                children: [
                                                    slide.halfTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "half-title",
                                                        children: slide.halfTitle
                                                    }),
                                                    slide.title && !slide.body && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "mb-4 mb-lg-0 h3",
                                                        children: slide.title
                                                    }),
                                                    slide.body && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mb-4 mb-lg-0",
                                                        dangerouslySetInnerHTML: {
                                                            __html: (_body = slide.body) !== null && _body !== void 0 ? _body : ""
                                                        }
                                                    }),
                                                    slide.imgSrc && slide.linkButton.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mt-4",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CTAButton, {
                                                            linkButton: slide.linkButton,
                                                            onClick: handleHubspot
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                className: "d-flex justify-content-end",
                                                lg: 6,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat((_BannerSlider_module_scss__WEBPACK_IMPORTED_MODULE_6___default().imgContainer)),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        alt: "CasperLabs",
                                                        width: 800,
                                                        height: 800,
                                                        src: slide.imgSrc
                                                    })
                                                })
                                            })
                                        ]
                                    }) || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                md: 8,
                                                lg: 7,
                                                children: [
                                                    slide.halfTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "half-title",
                                                        children: slide.halfTitle
                                                    }),
                                                    slide.title && !slide.body && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "mb-4 mb-lg-0 h3",
                                                        children: slide.title
                                                    }),
                                                    slide.body && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mb-4 mb-lg-0",
                                                        dangerouslySetInnerHTML: {
                                                            __html: (_body1 = slide.body) !== null && _body1 !== void 0 ? _body1 : ""
                                                        }
                                                    }),
                                                    slide.imgSrc && slide.linkButton.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CTAButton, {
                                                        linkButton: slide.linkButton,
                                                        onClick: handleHubspot
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                className: "d-flex justify-content-end",
                                                md: 4,
                                                lg: 5,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CTAButton, {
                                                    linkButton: slide.linkButton,
                                                    onClick: handleHubspot
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }, index))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atk_components_layout_Modal_HotspotModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                formId: hubspotFormId,
                target: "#getCTAHubspotForm",
                showModal: showReportModal,
                handleClose: handleCloseReportModal,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "getCTAHubspotForm"
                })
            })
        ]
    });
}


/***/ }),

/***/ 4583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* reexport */ getSlides; }
});

// UNUSED EXPORTS: WorkDetail

;// CONCATENATED MODULE: ./src/modules/common/components/BannerSlider/BannerSlider.types.ts
const getSlides = (banners)=>{
    return banners.map((banner)=>{
        var ref;
        return {
            id: banner._id,
            col1: banner.thumbnailUrl ? 6 : 8,
            col2: banner.thumbnailUrl ? 6 : 4,
            halfTitle: banner.sectionTitle,
            title: banner.title,
            body: banner.body,
            imgSrc: banner.thumbnailUrl,
            isAnimated: banner.isAnimated,
            linkButton: {
                label: banner.cta,
                link: banner.url,
                hubspotFormId: (ref = banner.integrations) === null || ref === void 0 ? void 0 : ref.hubspotFormId,
                variant: "secondary",
                target: banner.url && banner.url.includes("casperlabs.io") ? "_self" : "_blank"
            }
        };
    });
};

// EXTERNAL MODULE: ./src/modules/common/components/BannerSlider/BannerSlider.tsx
var BannerSlider = __webpack_require__(2045);
;// CONCATENATED MODULE: ./src/modules/common/components/BannerSlider/index.ts




/***/ }),

/***/ 6025:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toast":"HotspotModal_toast__TrTg5"};

/***/ }),

/***/ 5973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"ListLoader_loaderContainer__hS6rF"};

/***/ }),

/***/ 2302:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerSlider":"BannerSlider_bannerSlider__M7Zbk","slide":"BannerSlider_slide__v1ube","imgContainer":"BannerSlider_imgContainer__i95wy","arrow":"BannerSlider_arrow__Q3J5D","prev":"BannerSlider_prev__k99I2","next":"BannerSlider_next__oMuvF"};

/***/ })

}]);